import React, { useEffect, useRef } from 'react';
import './NumberSelectionPopup.css';

const NumberSelectionPopup = ({ position, onSelect, onClose }) => {
  const popupRef = useRef(null);
  
  // 吹き出しの位置を調整
  const getAdjustedPosition = () => {
    if (!popupRef.current) return position;
    
    const popupRect = popupRef.current.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    
    let { top, left } = position;
    
    // アロー（矢印）の位置を再調整するための情報
    let arrowLeft = 20; // デフォルトのアロー位置
    let arrowPosition = 'top'; // アローの位置（上または下）
    
    // 吹き出しが画面右端からはみ出る場合
    const isRightOverflow = left + popupRect.width > windowWidth - 10;
    if (isRightOverflow) {
      // 右端からはみ出る場合、左側に表示
      left = Math.max(10, windowWidth - popupRect.width - 10);
      // アローの位置を調整（セルに合わせる）
      const cellCenter = position.left;
      arrowLeft = Math.min(
        Math.max(20, cellCenter - left),
        popupRect.width - 20
      );
    }
    
    // 吹き出しが画面下端からはみ出る場合
    const isBottomOverflow = top + 30 + popupRect.height > windowHeight - 10;
    if (isBottomOverflow) {
      // 下端からはみ出る場合、上側に表示
      top = top - popupRect.height - 30;
      arrowPosition = 'bottom';
    } else {
      // 通常通り下側に表示
      top = top + 30;
    }
    
    return { 
      top, 
      left, 
      arrowLeft, 
      arrowPosition 
    };
  };
  
  // クリックイベントリスナーを設定
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);
  
  // スタイルを計算
  const adjPosition = getAdjustedPosition();
  const popupStyle = {
    top: `${adjPosition.top}px`,
    left: `${adjPosition.left}px`
  };
  
  // 矢印のスタイルを設定
  const arrowStyle = {
    left: `${adjPosition.arrowLeft}px`
  };
  
  return (
    <div className="number-selection-overlay">
      <div 
        ref={popupRef}
        className="number-selection-popup" 
        style={popupStyle}
      >
        <div 
          className={`popup-arrow ${adjPosition.arrowPosition === 'bottom' ? 'arrow-bottom' : 'arrow-top'}`} 
          style={arrowStyle}
        ></div>
        <div className="popup-content">
          <div className="number-grid">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(number => (
              <button
                key={number}
                className="popup-number-button"
                onClick={() => onSelect(number)}
              >
                {number}
              </button>
            ))}
            <button
              className="popup-clear-button"
              onClick={() => onSelect(0)}
            >
              クリア
            </button>
          </div>
          <button className="popup-close-button" onClick={onClose}>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default NumberSelectionPopup;